import { useEffect } from "react";
import { Service } from "../../models/WebsiteModels";
import { resolveImageUrl } from "../../utils/ImageUrl";

interface PublicServiceModalProps {
  service: Service;
  onClose: () => void;
}

const formatPrice = (
  price?: number | null,
  currency?: string | null,
): string =>
  price != null
    ? `${currency || "BDT"} ${Number(price).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "Price on request";

const PublicServiceModal = ({ service, onClose }: PublicServiceModalProps) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="psite-modal"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={service.name}
    >
      <div
        className="psite-modal__card psite-modal__card--service"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="psite-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div className="psite-modal__media psite-modal__media--banner">
          {service.imageUrl ? (
            <img src={resolveImageUrl(service.imageUrl)} alt={service.name} />
          ) : (
            <span>{service.name.charAt(0).toUpperCase()}</span>
          )}
        </div>
        <div className="psite-modal__body">
          <h3>{service.name}</h3>
          <div className="psite-modal__meta">
            {service.price != null && (
              <span className="psite-modal__chip">
                {formatPrice(service.price, service.currency)}
              </span>
            )}
            {service.durationMinutes != null && (
              <span className="psite-modal__chip">
                {service.durationMinutes} min
              </span>
            )}
            {service.category && (
              <span className="psite-modal__chip">{service.category}</span>
            )}
          </div>
          <p className="psite-modal__bio">
            {service.description || "No description available for this service yet."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PublicServiceModal;